import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { Nav } from "./components/Nav";
import { Hero } from "./components/Hero";
import { Marquee } from "./components/Marquee";
import { Features } from "./components/Features";
import { FAQ } from "./components/FAQ";
import { Footer } from "./components/Footer";
import PrivacyPage from "./pages/PrivacyPage";

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { err: false };
    }
    static getDerivedStateFromError() {
        return { err: true };
    }
    render() {
        if (this.state.err) {
            return (
                <div className="flex min-h-screen items-center justify-center bg-[#0A0A0B] text-white">
                    Something went wrong. Please refresh.
                </div>
            );
        }
        return this.props.children;
    }
}

const ScrollToTop = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);
    return null;
};

const Home = () => (
    <>
        <Nav />
        <main>
            <Hero />
            <Marquee />
            <Features />
            <FAQ />
        </main>
        <Footer />
    </>
);

export default function App() {
    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
        window.__lenis = lenis;
        let raf;
        const loop = (t) => {
            lenis.raf(t);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    return (
        <ErrorBoundary>
            <BrowserRouter>
                <ScrollToTop />
                <div className="grain min-h-screen bg-[#0A0A0B] text-[#F2F2EF]">
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/privacy" element={<PrivacyPage />} />
                    </Routes>
                    <Toaster
                        position="bottom-center"
                        theme="dark"
                        toastOptions={{
                            style: {
                                background: "#141416",
                                border: "1px solid rgba(255,255,255,0.1)",
                                color: "#F2F2EF",
                            },
                        }}
                    />
                </div>
            </BrowserRouter>
        </ErrorBoundary>
    );
}
